import {AfterContentChecked, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {GlobalConfig} from '../../global';
import {LoaderService} from '../config/loader-service.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit, AfterContentChecked {


  system: System = new System();
  langs = Array<Lang>();
  mainPage: boolean = false;

  constructor(public router: Router,
              public translate: TranslateService,
              public loader: LoaderService,
              private ref: ChangeDetectorRef) {
    translate.setDefaultLang('kz');
    this.checkMainPage()
  }

  ngOnInit(): void {
    this.getLangsList();
  }

  ngAfterContentChecked() {
    this.ref.detectChanges();
  }

  checkMainPage() {
    this.router.events.subscribe((val) => {
      let url = this.router.routerState.snapshot.url
      this.mainPage = url.includes('main') || url === '/';
    })

  }

  selectLang(e): void {
    this.translate.use(e.code);
    sessionStorage.setItem('lang', e.code);
  }


  getLangsList() {
    this.langs = Array<Lang>();
    this.langs.push(new Lang(1, 'ҚАЗ', 'kz'));
    this.langs.push(new Lang(2, 'РУС', 'ru'));
    this.langs.push(new Lang(2, 'ENG', 'en'));
    this.system = new System();

    // set lang to select option
    this.setLangSelectOption();
  }

  setLangSelectOption() {
    let lang = sessionStorage.getItem('lang');
    if (lang) {
      this.langs.forEach((element, index) => {
        if (element.code === lang) {
          this.system.lang = this.langs[index]
          this.translate.use(element.code);
        }
      });
    } else {
      this.system.lang = this.langs[0];
      let systemLang = this.system.lang.code;
      sessionStorage.setItem('lang', systemLang)
      this.translate.use(systemLang);
    }
  }

  openSocial(link: string) {
    window.open(link)
  }

  redirectToAuth() {
    window.location.href = GlobalConfig.ADMIN_URL;
  }
}

export class System {
  lang: Lang;
}

export class Lang {
  constructor(id: number, name: string, code: string) {
    this.id = id;
    this.name = name;
    this.code = code;
  }

  id: number;
  name: string;
  code: string;
}

